import React from "react";
import { NewTab, PageTab } from "../../../../components";
import NewTableAdvList from "./TableList/NewTableAdvList";
import RankTableList from "./TableList/RankTableList";
import AssignTableList from "./TableList/AssignTableList";
import NewTableList from "./TableList/NewTableList";
import { TableAdvList } from "./TableList/TableAdvList";
import TimeSheetList from "./TableList/TimeSheetList";
import NewTablePinSelectedList from "./TableList/NewTablePinSelectedList";

const TableList = () => {
  const tabList = [
    {
      title: "Table Adv",
      page: <TableAdvList />,
      type: "main",
    },
    {
      title: "Time Sheet",
      page: <TimeSheetList />,
      type: "main",
    },
    {
      title: "New Table Adv",
      page: <NewTableAdvList />,
      type: "main",
    },
    {
      title: "New Table",
      page: <NewTableList />,
      type: "main",
    },
    {
      title: "Rank Table",
      page: <RankTableList />,
      type: "main",
    },
    {
      title: "Assign Table",
      page: <AssignTableList />,
      type: "main",
    },
    {
      title: "New Table Pin Selected",
      page: <NewTablePinSelectedList />,
      type: "main",
    },
  ];

  return (
    <div className="w-full p-2 flex flex-1 overflow-hidden">
      <NewTab
        tabs={tabList}
        color="black"
        variant="text"
        activeVariant="text"
        mode="url"
        tabId="table-list"
      />
    </div>
  );
};

export default TableList;
